{
  "name": "audio-tour-player",
  "version": "1.2.4",
  "type": "module",
  "files": [
    "dist",
    "README.md",
    "CONTRIBUTING.md",
    "sw.js",
    "LICENSE"
  ],
  "main": "./dist/audio-tour-player.js",
  "module": "./dist/audio-tour-player.js",
  "exports": {
    ".": {
      "import": "./dist/audio-tour-player.js",
      "require": "./dist/audio-tour-player.umd.cjs"
    },
    "./style.css": "./dist/style.css"
  },
  "keywords": [
    "web-component",
    "audio-player",
    "pwa",
    "offline-first",
    "tour-guide"
  ],
  "author": "Dean Jenkins dean@celticquietplaces.com",
  "license": "Non-commercial use only. See LICENSE file for details.",
  "scripts": {
    "dev": "npm run copy-sw && vite",
    "build": "npm run copy-sw && vite build",
    "preview": "npm run build && node prepare-site.js && vite preview",
    "copy-sw": "echo '// DO NOT EDIT THIS COPY OF sw.js' | cat - sw.js > public/sw.js"
  },
  "devDependencies": {
    "vite": "^8.0.0"
  },
  "dependencies": {
    "terser": "^5.46.1"
  }
}
